import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';
import { Text } from '@mantine/core';
import styled from 'styled-components';
import { PredefinedIcons } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.types';

interface IBottomSectionDetails {
	text?: string;
	icon?: PredefinedIcons;
	action?: () => void;
}
interface ICardBottomSection {
	className?: string;
	date?: string;
	bottomRight?: IBottomSectionDetails;
}
const TextIconWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 0.25rem;
	cursor: pointer;
`;
export const CardBottomSection = styled(({ className, date, bottomRight }: ICardBottomSection) => {
	return (
		<div className={className}>
			{date && (
				<Text
					size="B6Medium"
					style={{
						color: defaultTheme.v3.colors.gray[0],
						textOverflow: 'ellipsis',
					}}
				>
					{date}
				</Text>
			)}
			<TextIconWrapper onClick={bottomRight?.action}>
				<Text
					size="B6Medium"
					style={{
						color: defaultTheme.v3.colors.gray[0],
						textOverflow: 'ellipsis',
					}}
				>
					{bottomRight?.text}
				</Text>
				{bottomRight && <Icon variant={bottomRight.icon as PredefinedIcons} size="xl" />}
			</TextIconWrapper>
		</div>
	);
})`
	width: 95%;
	padding: 0.5rem;
	display: flex;
	align-items: center;
	justify-content: space-between;
	.svg {
		fill: ${defaultTheme.v3.colors.blue[4]};
		color: ${defaultTheme.v3.colors.blue[4]};
	}
`;
